module.exports = __webpack_public_path__ + "assets/img/3.1e713509.jpg";